// src/components/ZodiacDetailModal.jsx
import React, { useState } from 'react';

const LEVEL_CLASS = {
  Alta: 'zodiac-badge--alta',
  Media: 'zodiac-badge--media',
  Desafiante: 'zodiac-badge--desafiante',
};

const ZodiacDetailModal = ({ sign, compatibilityList, onClose }) => {
  const [tab, setTab] = useState('general');
  if (!sign) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-content--zodiac" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-btn" aria-label="Cerrar">✕</button>

        <div className="zodiac-detail-header">
          <div className="zodiac-detail-symbol">{sign.symbol}</div>
          <div>
            <h3 className="zodiac-detail-name font-cinzel">{sign.name}</h3>
            <p className="zodiac-detail-dates">{sign.dateRange}</p>
          </div>
        </div>

        <div className="zodiac-detail-tags">
          <span className="zodiac-tag">{sign.element}</span>
          <span className="zodiac-tag">{sign.modality}</span>
          <span className="zodiac-tag">{sign.rulingPlanetSymbol} {sign.rulingPlanet}</span>
          <span className="zodiac-tag">🎴 {sign.tarotCard}</span>
          <span className="zodiac-tag">"{sign.keyword}"</span>
        </div>

        <div className="zodiac-tabs">
          <button className={`zodiac-tab ${tab === 'general' ? 'zodiac-tab--active' : ''}`} onClick={() => setTab('general')}>Perfil</button>
          <button className={`zodiac-tab ${tab === 'mitologia' ? 'zodiac-tab--active' : ''}`} onClick={() => setTab('mitologia')}>Mitología y Decanatos</button>
          <button className={`zodiac-tab ${tab === 'compat' ? 'zodiac-tab--active' : ''}`} onClick={() => setTab('compat')}>Compatibilidad</button>
        </div>

        {tab === 'general' && (
          <>
            <p className="zodiac-detail-description">{sign.description}</p>

            <div className="zodiac-detail-traits">
              <div className="meaning-block">
                <h4 className="meaning-label">✨ Fortalezas</h4>
                <p className="meaning-text">{sign.positiveTraits.join(' · ')}</p>
              </div>
              <div className="meaning-block">
                <h4 className="meaning-label">⚠️ Desafíos</h4>
                <p className="meaning-text">{sign.negativeTraits.join(' · ')}</p>
              </div>
            </div>

            <div className="zodiac-detail-life">
              <div className="meaning-block">
                <h4 className="meaning-label">💕 Amor</h4>
                <p className="meaning-text">{sign.love}</p>
              </div>
              <div className="meaning-block">
                <h4 className="meaning-label">💼 Carrera</h4>
                <p className="meaning-text">{sign.career}</p>
              </div>
              <div className="meaning-block">
                <h4 className="meaning-label">🩺 Salud</h4>
                <p className="meaning-text">{sign.health}</p>
              </div>
            </div>

            <div className="zodiac-detail-extra">
              <div className="zodiac-extra-item"><strong>Color:</strong> {sign.color}</div>
              <div className="zodiac-extra-item"><strong>Piedra:</strong> {sign.stone}</div>
              <div className="zodiac-extra-item"><strong>Número de la suerte:</strong> {sign.luckyNumber}</div>
              <div className="zodiac-extra-item"><strong>Parte del cuerpo:</strong> {sign.bodyPart}</div>
              <div className="zodiac-extra-item"><strong>Animal:</strong> {sign.animal}</div>
              <div className="zodiac-extra-item"><strong>Planta:</strong> {sign.plant}</div>
              <div className="zodiac-extra-item"><strong>Metal:</strong> {sign.metal}</div>
            </div>
          </>
        )}

        {tab === 'mitologia' && (
          <>
            <div className="meaning-block">
              <h4 className="meaning-label">📜 Mitología del símbolo</h4>
              <p className="meaning-text">{sign.mythology}</p>
            </div>

            <div className="meaning-block">
              <h4 className="meaning-label">🌓 Los 3 decanatos</h4>
              <div className="zodiac-decans-list">
                {sign.decans.map((d, i) => (
                  <div key={i} className="zodiac-decan-item">
                    <span className="zodiac-decan-range">{d.range} — {d.planet}</span>
                    <p className="zodiac-decan-desc">{d.description}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="meaning-block">
              <h4 className="meaning-label">☯️ Signo opuesto: {sign.oppositeSign}</h4>
              <p className="meaning-text">{sign.oppositeDescription}</p>
            </div>

            <div className="meaning-block">
              <h4 className="meaning-label">🌟 Personas célebres</h4>
              <p className="meaning-text">{sign.famousPeople.join(' · ')}</p>
            </div>
          </>
        )}

        {tab === 'compat' && (
          <div className="zodiac-compat-matrix">
            {(compatibilityList || []).map((c) => (
              <div key={c.sign} className="zodiac-compat-row">
                <div className="zodiac-compat-row-header">
                  <span className="zodiac-compat-sign">{c.sign}</span>
                  <span className={`zodiac-badge ${LEVEL_CLASS[c.level] || ''}`}>{c.level}</span>
                </div>
                <p className="zodiac-compat-text">{c.text}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ZodiacDetailModal;
